const useLocalStorage = () => {
  const getItem = (key, type = "JSON") => {
    if (!window || typeof window === "undefined") return "";

    if (type === "JSON") {
      return JSON.parse(window.localStorage.getItem(key));
    } else if (type === "NUMBER") {
      return Number(window.localStorage.getItem(key));
    } else if (type === "BOOLEAN") {
      return window.localStorage.getItem(key) === "true" ? true : false;
    }
  };

  const setItem = (key, value, type = "JSON") => {
    if (!window || typeof window === "undefined") return "";

    if (type === "JSON") {
      window.localStorage.setItem(key, JSON.stringify(value));
    } else {
      window.localStorage.setItem(key, value);
    }
  };

  const deleteKey = (key) => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
    }
  };

  return {
    getItem,
    setItem,
    deleteKey,
  };
};

export default useLocalStorage;
